module.exports = __webpack_public_path__ + "static/Oswald-Bold-4b3d384ba3e97f95711f7422587485b1.woff";